import React from 'react';

import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
  usePermissions,
} from 'react-admin';
import { ResetAuthUserButton } from './ResetAuthUserButton';

const TeacherEdit = (props) => {
  const { permissions } = usePermissions();
  return (
    <Edit {...props} title="Edit teacher">
      <SimpleForm>
        <TextInput disabled source="id" style={{ display: 'none' }} />
        <TextInput source="first_name" />
        <TextInput source="last_name" />
        <TextInput source="email" />
        <TextInput source="mobile" />
        {/* <ReferenceInput label="Class" source="class_id" reference="classes" /> */}
        <ReferenceInput source="class_id" reference="classes">
          <SelectInput label="Class" source="class_id" optionText="class_code" />
        </ReferenceInput>
        <SelectInput
          source="role"
          choices={[
            { id: 'teacher', name: 'Teacher' },
            { id: 'trainer', name: 'Trainer' },
            { id: 'principal', name: 'Principal' },
            permissions === 'admin' ? { id: 'admin', name: 'Admin' } : {},
          ]}
          emptyText="Unknown"
          emptyValue="unknown"
        />
        <TextInput
          source="invited_at"
          defaultValue="NEVER INVITED"
          disabled
          style={{ width: 400 }}
        />
        <TextInput
          source="last_sign_in_at"
          defaultValue="NEVER SIGNED IN"
          disabled
          style={{ width: 400 }}
        />
        <ResetAuthUserButton />
      </SimpleForm>
    </Edit>
  );
};

export default TeacherEdit;

